import "./Support.module.css";
import Header from "@/reusable_sections/Header";
import StayUpdated from "./sections/StayUpdated";
import Footer from "@/reusable_sections/Footer";
export default function SupportPage() {
  return <div>
      <Header />
      <StayUpdated />
      <Footer />
    </div>;
}